import base64 from 'base-64';
import utf8 from 'utf8';

// NOTE: We first utf8-encode the string before we base64-encode it.
// We do the reverse during decoding. For a more in depth reason why see:
// https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#The_Unicode_Problem

export const encodeBase64 = str => base64.encode(utf8.encode(str));

export const decodeBase64 = str => utf8.decode(base64.decode(str));
